import React, { useContext, useEffect, useMemo, useState } from "react";
import { useLocation, matchPath, useHistory } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { CiCreditCard1 } from "react-icons/ci";
import PropTypes from "prop-types";
import { LiaShareAltSolid } from "react-icons/lia";
import { BiSupport } from "react-icons/bi";
import { BiClinic } from "react-icons/bi";
import { MdNotificationsNone } from "react-icons/md";
import { FaAddressBook, FaUserGroup } from "react-icons/fa6";
import { GrTransaction } from "react-icons/gr";
import { MdOutlineSubscriptions } from "react-icons/md";
import { CiNoWaitingSign } from "react-icons/ci";
import { GrUserAdmin } from "react-icons/gr";


import { MdDashboard } from "react-icons/md";
import { MdPayments } from "react-icons/md";
import { MdOutlineHolidayVillage } from "react-icons/md";
import { RiLockPasswordFill } from "react-icons/ri";
import { FaCodeCommit } from "react-icons/fa6";

import {
  Box,
  Drawer,
  Hidden,
  List,
  Button,
  ListSubheader,
  makeStyles,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide,
} from "@material-ui/core";
import NavItem from "./NavItem";
import { BiBookContent } from "react-icons/bi";
import { AuthContext } from "src/context/Auth";
import { GiTatteredBanner } from "react-icons/gi";
import VideoCallIcon from "@material-ui/icons/VideoCall";

function renderNavItems({ items, pathname, depth = 0, state, setSelectedTab, onNavItemClick }) {
  return (
    <List disablePadding>
      {items.reduce(
        (acc, item) =>
          reduceChildRoutes({
            acc,
            item,
            pathname,
            depth,
            state,
            setSelectedTab,
            onNavItemClick,
          }),
        []
      )}
    </List>
  );
}

function reduceChildRoutes({
  acc,
  pathname,
  item,
  depth,
  state,
  setSelectedTab,
  onNavItemClick,
}) {
  const key = item.title + depth;

  if (item.items) {
    const open = matchPath(pathname, {
      path: item.href,
      exact: false,
    });
    const isActive =
      item.type == "moneyTransfer" && pathname == "/money-transfer-withdraw";

    acc.push(
      <NavItem
        depth={depth}
        icon={item.icon}
        info={item.info}
        key={key}
        open={
          Boolean(isActive || open) ||
          item.items.some((child) =>
            matchPath(pathname, { path: child.href, exact: true })
          )
        } // Keep parent item open if any of its children match the current path
        title={item.title}
        // bagde={item.bagde}
        setSelectedTab={(item) => setSelectedTab(item)}
      >
        {renderNavItems({
          depth: depth + 1,
          pathname,
          items: item.items,
          state,
          // bagde:item.bagde,
          setSelectedTab,
          onNavItemClick,
        })}
      </NavItem>
    );
  } else {
    acc.push(
      <NavItem
        depth={depth}
        href={item.href}
        icon={item.icon}
        info={item.info}
        tabview={item.tabview}
        key={key}
        title={item.title}
        bagde={item.bagde}
        setSelectedTab={(item) => setSelectedTab(item)}
        onNavItemClick={onNavItemClick}
        item={item}
      />
    );
  }
  return acc;
}

const useStyles = makeStyles((theme) => ({
  mobileDrawer: {
    width: 320,
    background: "#fff",
    boxShadow: "0px 0px 7px rgb(0 0 0 / 11%)",
  },
  desktopDrawer: {
    top: "78px",
    width: "300px",
    height: "calc(100% - 75px)",
    zIndex: "1",
    // margin: "5px 10px 10px 15px",
    background: "#fff",
    boxShadow: "0px 0px 7px rgb(0 0 0 / 11%)",
  },

  avatar: {
    cursor: "pointer",
    width: 64,
    height: 64,
  },
  socialIcon: {
    cursor: "pointer",
    marginRight: 5,
  },
  button: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "left",
    height: "45px",
    paddingLeft: "17px",
    borderRadius: "12px",
    marginTop: "-30px",
    "&:hover": {
      color: "#F5C843",
    },
    "& svg": {
      color: "#F5C843",
      fontSize: "20px",
    },
  },
  btnBox: {
    position: "relative",
    left: "30%",
    bottom: "-250px",
  },
  logoutButton: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    // position: "absolute",
    bottom: "19px",
    left: "32px",
    background: "transparent",
    fontWeight: "400",
    fontSize: "13px",
    color: "#000",
  },
  sideMenuBox: {
    "& .MuiCollapse-wrapperInner": {
      marginLeft: "45px",
    },
  },
  "& .makeStyles-buttonLeaf-29.depth-0 .makeStyles-title-31": {
    fontSize: "16px",
    fontWeight: 600,
    // background: "inear-gradient(254.2deg, #21FFBC -18.97%, #2613FF 97.92%)",
  },
}));

const sections = [
  {
    items: [
      {
        title: "Dashboard",
        icon: MdDashboard,
        href: "/dashboard",
        type: "home",
      },
      {
        title: "Clinic Management",
        icon: BiClinic,
        // href: "/supportChat",
        href: "/clinic-list",
        type: "clinic",
        bagde: 20,
      },
      {
        title: "User Management",
        icon: FaUserGroup,
        href: "/user-list",
        type: "parent",
      },

      {
        title: "Subscription Management",
        icon: MdOutlineSubscriptions,
        href: "/subscription",
        type: "subscription",
      },
      {
        title: "Appointment Management",
        icon: CiNoWaitingSign,
        href: "/appointment",
        type: "appointment",
      },
      // {
      //   title: "Meeting Management",
      //   icon: VideoCallIcon,
      //   href: "/meeting-management",
      //   type: "meeting",
      // },
      {
        title: "Blog Management",
        icon: BiBookContent,
        href: "/blog-management",
        type: "blog",
      },

      {
        title: "Team Management",
        icon: BiBookContent,
        href: "/team-list",
        type: "team",
      },

      {
        title: " Subscription Transaction",
        icon: GrTransaction,
        href: "/subscription-transaction",
        type: "transaction",
      },
      //       {
      //   title: " Clinic Transaction",
      //   icon: GrTransaction,
      //   href: "/clinic-transaction",
      //   type: "clinic",
      // },
      // {
      //   title: "Subadmin Management",
      //   icon: GrUserAdmin,
      //   href: "/sub-admin",
      //   type: "sub-admin",
      // },

      {
        title: "Profile Management",
        icon: FaAddressBook,
        href: "/edit-profile",
        type: "profile",
      },
    ],
  },
];

const sectionClinic = [
  {
    items: [
      {
        title: "Dashboard",
        icon: MdDashboard,
        href: "/clinic-dashboard",
        type: "home",
      },
      {
        title: "Donor",
        icon: BiSupport,
        href: "/donor",
        type: "donor",
      },
      {
        title: "Appointment Management",
        icon: BiBookContent,
        href: "/clinic-appointment",
        type: "Appointment",
      },
      {
        title: "Meeting Management",
        icon: VideoCallIcon,
        href: "/meeting-management",
        type: "meeting",
      },
      {
        title: "Subscription Management",
        icon: VideoCallIcon,
        href: "/subscription-clinic",
        type: "subscription-clinic",
      },

      {
        title: "Api Response",
        icon: BiBookContent,
        href: "/response",
        type: "response",
      },
      {
        title: "Profile Management",
        icon: FaAddressBook,
        href: "/edit-profile",
        type: "changepassword",
      },
    ],
  },
];

const NavBar = ({ onMobileClose, openMobile, tabView, setSelectedTab }) => {
  const classes = useStyles();
  const location = useLocation();

  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [isLogout, setIsLogout] = useState(false);
  const [subscriptionModal, setSubscriptionModal] = useState(false);
  const [clickedItem, setClickedItem] = useState(null);

  const data = useContext(AuthContext);
console.log("sdgsadgads",data);

  // Utility function to check if user has permission for a specific item
  const checkUserPermission = (itemType, permissions) => {
    if (!permissions || !itemType) return false;
    return permissions[itemType] === true;
  };

  // Function to check subscription and handle navigation
  const handleNavItemClick = (item) => {
    // If user is clinic and subscription is false, show modal for most items
    if (userType === "clinic" && !clinicSubscription) {
      // Allow access to subscription management and dashboard
      if (item.type === "subscription-clinic" || item.type === "home") {
        history.push(item.href);
      } else {
        // Show subscription modal for other items
        setClickedItem(item);
        setSubscriptionModal(true);
      }
    } else {
      // Normal navigation for other cases
      history.push(item.href);
    }
  };

  // Function to handle subscription modal actions
  const handleSubscriptionModalClose = () => {
    setSubscriptionModal(false);
    setClickedItem(null);
  };

  const handlePurchaseSubscription = () => {
    setSubscriptionModal(false);
    setClickedItem(null);
    history.push("/subscription-clinic");
  };
  const userId = data?.userData?.data?.user?.id;
  const userType = data?.userData?.data?.user?.user_type;
  const permissionsData = data?.userData?.data?.user?.permissions;
  const clinicSubscription = data?.userData?.data?.user?.subscription;
console.log("fgdsfgdfsgdfs",clinicSubscription);

  // Debug logging for permissions
  if (userType === "subadmin") {
    console.log("User Type:", userType);
    console.log("Permissions Data:", permissionsData);
  }

  // const filteredSections = useMemo(() => {
  //   if (!permissions || data?.userData?.userType === "ADMIN") return sections; // If permissions are not defined, return the original sections

  //   return sections.map((section) => ({
  //     items: section.items.filter((item) => {
  //       const itemType = item.type;
  //       if (permissions[itemType] !== false) {
  //         return permissions[itemType];
  //       }
  //       return false;
  //     }),
  //   }));
  // }, [permissions, data]);

  const filteredSections = useMemo(() => {
    switch (userType) {
      case "admin":
        return sections;
      case "clinic":
        return sectionClinic;
      case "subadmin":
        // Filter sections based on permissions for subadmin
        if (!permissionsData) {
          console.warn("No permissions data found for subadmin user");
          return [];
        }

        return sections
          .map((section) => ({
            ...section,
            items: section.items.filter((item) => {
              // Dashboard should always be shown for subadmin users
              if (item.type === "home") {
                console.log(
                  `Item: ${item.title}, Type: ${item.type}, Always Show: true (Dashboard)`
                );
                return true;
              }

              // Check if the item type has a corresponding permission
              const permissionKey = item.type;
              const userHasPermission = checkUserPermission(
                permissionKey,
                permissionsData
              );

              // Debug log for each item
              console.log(
                `Item: ${item.title}, Type: ${permissionKey}, Has Permission: ${userHasPermission}`
              );

              return userHasPermission;
            }),
          }))
          .filter((section) => section.items.length > 0); // Remove empty sections

        // Log summary of what items are being displayed
        const displayedItems = sections.flatMap((section) =>
          section.items.filter((item) =>
            checkUserPermission(item.type, permissionsData)
          )
        );
       
      case "clinic":
        return sectionClinic;
      case "USER":
        return []; // Return empty array instead of empty string
      default:
        return sections; // fallback to default
    }
  }, [userType, permissionsData]); // Depend on both userType and permissionsData

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  const content = (
    <Box height="100%" display="flex" flexDirection="column">
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <Box p={2}>
          <Box className="sideMenuBox">
            {filteredSections?.map((section, i) => (
              <List
                key={`menu${i}`}
                subheader={
                  <ListSubheader disableGutters disableSticky>
                    {section.subheader}
                  </ListSubheader>
                }
              >
                {renderNavItems({
                  img: section.img,
                  items: section.items,
                  pathname: location.pathname,
                  state: section.tabView,
                  setSelectedTab,
                  onNavItemClick: handleNavItemClick,
                })}
              </List>
            ))}
          </Box>
        </Box>

        <Button
          onClick={() => setIsLogout(true)}
          className={classes.logoutButton}
        >
          <ExitToAppIcon
            style={{
              marginRight: "16px",
            }}
          />
          &nbsp; Logout
        </Button>

        {isLogout && (
          <Dialog
            maxWidth="sm"
            fullWidth
            className={classes.dailogOpen}
            open={isLogout}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => setIsLogout(false)}
          >
            <DialogContent>
              <Box className={classes.dialougTitle} align="center">
                <Typography variant="h6" color="primary">
                  Are you sure want to logout?
                </Typography>
              </Box>
            </DialogContent>
            <DialogActions
              style={{
                alignContent: "center",
                justifyContent: "center",
              }}
            >
              <Box mt={2}>
                <Button
                  className="modelbtn"
                  color="secondary"
                  variant="contained"
                  style={{ padding: "8px 21px" }}
                  onClick={() => setIsLogout(false)}
                >
                  No
                </Button>
                &nbsp; &nbsp;
                <Button
                  className="modelbtnyes"
                  style={{
                    padding: "8px 21px",
                  }}
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    sessionStorage.removeItem("adminToken");
                    sessionStorage.removeItem("userType");
                    sessionStorage.removeItem("creatturAccessToken");
                    localStorage.removeItem("clinicToken");
                    sessionStorage.removeItem("clinicToken");

                    // Navigate to login page
                    history.push("/");

                    // Optional: Show logout success message
                    // toast.success("Logged out successfully");
                  }}
                >
                  Yes
                </Button>
              </Box>
            </DialogActions>
          </Dialog>
        )}

        {/* Subscription Modal */}
        {subscriptionModal && (
          <Dialog
            maxWidth="sm"
            fullWidth
            className={classes.dailogOpen}
            open={subscriptionModal}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleSubscriptionModalClose}
          >
            <DialogTitle>
              <Typography variant="h6" color="primary" align="center">
                Subscription Required
              </Typography>
            </DialogTitle>
            <DialogContent>
              <Box align="center">
                <Typography variant="body1" color="primary" style={{ marginBottom: "16px",color:"#000" }}>
                  You need an active subscription to access this feature.
                </Typography>
                <Typography variant="body2" color="primary">
                  Please purchase a subscription to continue using {clickedItem?.title}.
                </Typography>
              </Box>
            </DialogContent>
            <DialogActions
              style={{
                alignContent: "center",
                justifyContent: "center",
              }}
            >
              <Box mt={2}>
                <Button
                  className="modelbtn"
                  color="secondary"
                  variant="contained"
                  style={{ padding: "8px 21px" }}
                  onClick={handleSubscriptionModalClose}
                >
                  Cancel
                </Button>
                &nbsp; &nbsp;
                <Button
                  className="modelbtnyes"
                  style={{
                    padding: "8px 21px",
                    backgroundColor: "#FF6C64",
                    color: "#fff",
                  }}
                  color="primary"
                  variant="contained"
                  onClick={handlePurchaseSubscription}
                >
                  Purchase Subscription
                </Button>
              </Box>
            </DialogActions>
          </Dialog>
        )}
      </PerfectScrollbar>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          classes={{ paper: classes.mobileDrawer }}
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
        >
          <Box p={2}>{content}</Box>
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Drawer
          anchor="left"
          classes={{ paper: classes.desktopDrawer }}
          open
          variant="persistent"
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

NavBar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

export default NavBar;
